import { ACADEMIC_DASHBOARD_ERROR, GETTING_ACADEMIC_DASHBOARD, GET_ACADEMIC_DASHBOARD } from "../types"

const initialState = {
    academicData: null,
    loadingAcademic: true,
    academicError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case GETTING_ACADEMIC_DASHBOARD:
        return {
            ...state,
            loadingAcademic: action.payload,
        }
        case GET_ACADEMIC_DASHBOARD:
        return{
            ...state,
            loadingAcademic: false,
            academicError: null,
            academicData: action.payload
        }
        case ACADEMIC_DASHBOARD_ERROR:
        return{
            ...state,
            loadingAcademic: false,
            academicError: action.payload
        }
        default:
        return state
    }
}
